"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import BaseToolbarButtonProp from "./BaseToolbarButton";
import { tbDeleteRowsClicked } from "Actions/Table/TableToolBarActions";
import { Messages } from "Messages";
import { System } from "Constants/objects";

var DeleteButtonProps =
/*#__PURE__*/
function (_BaseToolbarButtonPro) {
  _inherits(DeleteButtonProps, _BaseToolbarButtonPro);

  function DeleteButtonProps(_ref) {
    var _this;

    var formUUID = _ref.formUUID,
        isContextMenu = _ref.isContextMenu,
        title = _ref.title,
        iconType = _ref.iconType,
        rest = _objectWithoutProperties(_ref, ["formUUID", "isContextMenu", "title", "iconType"]);

    _classCallCheck(this, DeleteButtonProps);

    var props = _objectSpread({
      isContextMenu: isContextMenu,
      text: title || Messages.Controls.Delete,
      hint: title || Messages.Controls.Delete,
      iconType: iconType || 'material:delete_forever',
      disabled: true,
      elementAttr: {
        'class': System.TOOLBAR_BTN_CLASSES.DEL
      },
      onClick: function onClick(e) {
        _this.UUID = _this._isContextMenu ? _this._props.UUID : _this._props.options.UUID;
        tbDeleteRowsClicked({
          event: e,
          formUUID: _this.UUID
        });
      }
    }, rest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DeleteButtonProps).call(this, props));
    isContextMenu ? _this._props.UUID = formUUID : _this._props.options.UUID = formUUID;
    return _this;
  }

  return DeleteButtonProps;
}(BaseToolbarButtonProp);

_defineProperty(DeleteButtonProps, "create", function (options) {
  return new DeleteButtonProps(options).props();
});

export { DeleteButtonProps as default };